const VisaLogo = ({ width = 60, height = 20, colorBase = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 200 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M78.5 49.5L85.5 15.5H97L90 49.5H78.5Z" fill={colorBase} />
    <path
      d="M126 16.5C123.5 15.5 119.5 14.5 114.5 14.5C103.5 14.5 95.8 20.2 95.7 28.3C95.6 34.3 101.2 37.7 105.4 39.7C109.7 41.7 111.1 43 111.1 44.8C111.1 47.5 107.7 48.8 104.5 48.8C100 48.8 97.6 48.1 93.8 46.4L92.3 45.7L90.7 55.2C93.6 56.5 99 57.7 104.6 57.7C116.3 57.7 123.8 52.1 123.9 43.4C124 38.6 121 35 114.4 32C110.5 30.1 108.1 28.8 108.1 26.9C108.1 25.2 110.1 23.4 114.4 23.4C118 23.3 120.6 24.1 122.6 25L123.6 25.5L126 16.5Z"
      fill={colorBase}
    />
    <path
      d="M151 15.5H142.3C139.7 15.5 137.7 16.3 136.6 19L120.5 49.5H132.2L134.6 42.8H148.7L150 49.5H160.3L151 15.5ZM137.8 34.2C138.7 31.8 142.3 22 142.3 22C142.2 22.2 143.2 19.6 143.8 18L144.6 21.6C144.6 21.6 147 32.2 147.5 34.3H137.8V34.2Z"
      fill={colorBase}
    />
    <path
      d="M68.3 15.5L57.4 38.8L56.2 33C54.1 26.2 47.8 18.8 40.8 15.1L50.7 49.4H62.5L80.2 15.5H68.3Z"
      fill={colorBase}
    />
    <path
      d="M47.2 15.5H29L28.8 16.4C43.1 20 52.5 29 56.2 33L52.4 19.2C51.7 16.5 49.7 15.6 47.2 15.5Z"
      fill="#FAA61A"
    />
  </svg>
);

export default VisaLogo;
